import { useContext } from "react";
import { FidelityContext } from "../../../context/FidelityContext";
import { useStyles } from "../styles";
import { Box } from "@material-ui/core";

const RenderComponent = ({ children, component }) => {
	const { tabsEnums, getCurrentTab } = useContext(FidelityContext);
	const canRender = getCurrentTab() === tabsEnums[component];
	const classes = useStyles();

	return (
		<Box data-display={canRender} className={classes.controller}>
			{children}
		</Box>
	);
};

export default RenderComponent;
